import { DetailedLabResultObservation } from '@pm/graphql';
import { Card, Text } from '@pm/ui';

import { useTranslation } from 'react-i18next';
import {
  BACKEND_GROUP_ID_STI_SCREENING,
  getTestSectionInfo,
} from './constants';
import { LabObservation } from './LabObservation';

type LabSectionProps = {
  category: string;
  observations: DetailedLabResultObservation[];
  providerName: string;
};

export const LabSection = ({
  category,
  observations,
  providerName,
}: LabSectionProps) => {
  const { t } = useTranslation('labs');
  const sectionInfo = getTestSectionInfo(category, t);

  const orderedObservations =
    category === BACKEND_GROUP_ID_STI_SCREENING
      ? [...observations].sort((a, b) => {
          const titleA = t(
            `TestNames.${providerName}_${a.providerTestIdentifier}.Title` as never,
            { defaultValue: '' },
          ) as string;
          const titleB = t(
            `TestNames.${providerName}_${b.providerTestIdentifier}.Title` as never,
            { defaultValue: '' },
          ) as string;
          return titleA.localeCompare(titleB);
        })
      : observations;

  return (
    <Card size="large">
      <div className="space-y-l">
        <div className="space-y-s">
          <Text size="headingS" as="h2">
            {sectionInfo.title}
          </Text>
          {sectionInfo.description && (
            <Text size="bodyS" color="contentSubdued">
              {sectionInfo.description}
            </Text>
          )}
          {sectionInfo.description2 && (
            <Text size="bodyS" color="contentSubdued">
              {sectionInfo.description2}
            </Text>
          )}
        </div>
        <div className="space-y-l">
          {orderedObservations.map((observation, index) => (
            <LabObservation
              key={observation.id}
              observation={observation}
              providerName={providerName}
              showDivider={index < orderedObservations.length - 1}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
